// Follow-ups are activities of kind 'Task'. Shared by the website, the app and the server's
// reminders, so all three agree on what is overdue and what is due today.
const RECORD_TYPES = ['contacts', 'companies', 'deals'];

// How long before a follow-up is due its reminder is sent (server/services/crmFollowUpReminder.js).
const FOLLOW_UP_REMINDER_MINUTES = 15;

const endOfDay = now => { const end = new Date(now); end.setHours(24, 0, 0, 0); return end.getTime(); };

/** 'overdue', 'today' (due later today), 'upcoming' or 'completed'; null for anything that is not a follow-up. */
function followUpStatus(activity, now = new Date()) {
    if (!activity || activity.kind !== 'Task') return null;
    if (activity.done) return 'completed';
    const due = new Date(activity.date).getTime();
    if (!Number.isFinite(due)) return 'upcoming';
    if (due < now.getTime()) return 'overdue';
    return due < endOfDay(now) ? 'today' : 'upcoming';
}

function followUpCounts(activities, now = new Date()) {
    const counts = { overdue: 0, today: 0, upcoming: 0, completed: 0, open: 0 };
    for (const activity of activities || []) {
        const status = followUpStatus(activity, now);
        if (!status) continue;
        counts[status] += 1;
        if (status !== 'completed') counts.open += 1;
    }
    return counts;
}

/*
 * A link that opens one record of the live CRM. Notifications carry it; the website reads it on
 * /crm and the app's notification handler reads it too. Parsed by hand: React Native's
 * URLSearchParams is incomplete.
 */
function crmRecordLink(recordType, recordId) {
    return `/crm?workspace=live&open=${encodeURIComponent(recordType)}:${encodeURIComponent(recordId)}`;
}

function parseCRMRecordLink(link) {
    const match = String(link || '').match(/[?&]open=([^&#]*)/);
    if (!match) return null;
    let value;
    try { value = decodeURIComponent(match[1]); } catch { return null; }
    const split = value.indexOf(':');
    const type = value.slice(0, split), id = value.slice(split + 1);
    return split > 0 && id && RECORD_TYPES.includes(type) ? { type, id } : null;
}

module.exports = { FOLLOW_UP_REMINDER_MINUTES, followUpStatus, followUpCounts, crmRecordLink, parseCRMRecordLink };
